import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import Chip from '@material-ui/core/Chip'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles({
    formHeader: {boxShadow: 'none'},
    deviceCount: {display: 'flex', flexDirection: 'column', alignItems: 'center'}
})

function CustomerInformation ({CustomerSAPID, Name, ProductType, Region, DeviceCount}) {
    const classes = useStyles()
    
    return (
        <Card className={classes.formHeader}>
            <CardHeader
                avatar={
                    <div className={classes.deviceCount}>
                        <Typography variant="caption" gutterBottom>Device Count</Typography>
                        <Chip color="secondary" label={DeviceCount} />
                    </div>
                }
                disableTypography={true}
                title={
                    <>
                        <Typography variant="h6">{ProductType}</Typography>
                        <Typography variant="h6">{Name}</Typography>
                    </>
                }
                subheader={<Typography variant="caption" color="textSecondary">{Region} - {CustomerSAPID}</Typography>}
            />
        </Card>
  )
}

export default CustomerInformation
